/**
 * Converts an opacity value to a 2-digit hex string
 * @param {Number} opacity
 * @return {String}
 */
const convertOpacityToHex = (opacity) => {
    const hexedOpacity = Math.floor(opacity * 255).toString(16);

    return hexedOpacity.length === 1 ? `0${hexedOpacity}` : hexedOpacity;
};

module.exports = convertOpacityToHex;
